import { render, staticRenderFns } from "./SourceManage.vue?vue&type=template&id=48ffcfa8&scoped=true"
import script from "./SourceManage.vue?vue&type=script&lang=js"
export * from "./SourceManage.vue?vue&type=script&lang=js"
import style0 from "./SourceManage.vue?vue&type=style&index=0&id=48ffcfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffcfa8",
  null
  
)

export default component.exports